import { render, staticRenderFns } from "./grow-up.vue?vue&type=template&id=6137d0ce&"
import script from "./grow-up.vue?vue&type=script&lang=js&"
export * from "./grow-up.vue?vue&type=script&lang=js&"
import style0 from "./grow-up.vue?vue&type=style&index=0&id=6137d0ce&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports